import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The −/count/+ pill used wherever a guest picks how many of an add-on they
 * want (listing booking widget, booking review, modify-trip modal). It only
 * emits the step; the caller owns the quantity and clamps it, so the pricing
 * and cap rules stay in one place per screen. Anything projected inside is
 * shown after the + button (e.g. "× $5.00 = $15.00").
 */
@Component({
  selector: 'cnt-add-on-qty-stepper',
  standalone: true,
  template: `
    <div class="inline-flex items-center gap-2 bg-white border border-dark-text/10 rounded-full pl-0.5 pr-3">
      <button
        type="button"
        (click)="step.emit(-1)"
        [disabled]="qty <= 1"
        class="w-11 h-11 rounded-full inline-flex items-center justify-center text-dark-text hover:bg-cream disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        [attr.aria-label]="'Decrease ' + label + ' quantity'"
      >
        <span aria-hidden="true" class="material-symbols-outlined text-base">remove</span>
      </button>
      <span class="font-body text-sm font-bold text-dark-text min-w-[1.5ch] text-center" aria-live="polite">{{ qty }}</span>
      <button
        type="button"
        (click)="step.emit(1)"
        [disabled]="qty >= max"
        class="w-11 h-11 rounded-full inline-flex items-center justify-center text-dark-text hover:bg-cream disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        [attr.aria-label]="'Increase ' + label + ' quantity'"
      >
        <span aria-hidden="true" class="material-symbols-outlined text-base">add</span>
      </button>
      <ng-content />
    </div>
  `,
})
export class AddOnQtyStepperComponent {
  @Input() qty = 1;
  @Input() max = 99;
  /** Add-on name, for the buttons' accessible labels. */
  @Input() label = '';
  @Output() step = new EventEmitter<1 | -1>();
}
